import { render } from "./PackageEnPageList.vue?vue&type=template&id=00b89589&scoped=true&ts=true"
import script from "./PackageEnPageList.vue?vue&type=script&lang=ts"
export * from "./PackageEnPageList.vue?vue&type=script&lang=ts"

import "./PackageEnPageList.vue?vue&type=style&index=0&id=00b89589&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b89589"]])

export default __exports__